import { ORG_ERROR_CODES, QUOTA_ERROR_CODES } from '@shared/constants/error-codes';
import { ApiError } from '@/lib/api-error';

const COMPANY_ERROR_MESSAGES: Record<string, string> = {
  EMAIL_RATE_LIMIT_EXCEEDED: 'Trop d’e-mails d’activation ont été demandés. Réessayez plus tard.',
  OBJECT_STORAGE_NOT_CONFIGURED: 'Le stockage objet n’est pas configuré sur cet environnement.',
  OBJECT_STORAGE_PUBLIC_URL_MISSING: 'Le stockage public des logos n’est pas correctement configuré.',
  [ORG_ERROR_CODES.COMPANY_LOGO_IMAGE_INVALID]: 'Cette image ne peut pas être utilisée comme logo.',
  [ORG_ERROR_CODES.COMPANY_LOGO_IMAGE_TOO_LARGE]: 'Le fichier logo dépasse la taille maximale autorisée.',
  [ORG_ERROR_CODES.COMPANY_MEMBER_ALREADY_EXISTS]: 'Cette adresse e-mail appartient déjà à un membre de l’entreprise.',
  [ORG_ERROR_CODES.COMPANY_MEMBER_ALREADY_VERIFIED]: 'Ce membre a déjà activé son compte.',
  [ORG_ERROR_CODES.COMPANY_MEMBER_DISABLED]: 'Réactivez ce membre avant de renvoyer son invitation.',
  [ORG_ERROR_CODES.INVITATION_SEND_FAILED]: 'Le compte existe, mais l’e-mail d’activation n’a pas pu être envoyé.',
  [ORG_ERROR_CODES.LAST_COMPANY_ADMIN]: 'L’entreprise doit conserver au moins un administrateur actif.',
  [ORG_ERROR_CODES.ORG_FORBIDDEN]: 'Vous ne disposez pas des droits requis dans cette entreprise.',
  [QUOTA_ERROR_CODES.COMPANY_QUOTA_EXCEEDED]: 'Le quota de l’entreprise est épuisé.',
};

const HTTP_ERROR_MESSAGES: Partial<Record<number, string>> = {
  400: 'La requête est invalide. Vérifiez les informations saisies.',
  401: 'Votre session a expiré. Veuillez vous reconnecter.',
  403: 'Vous ne disposez pas des droits requis pour cette action.',
  404: 'Le membre ou l’entreprise demandé n’existe pas.',
  409: 'Cette opération entre en conflit avec l’état actuel du membre.',
  422: 'Les informations saisies sont invalides.',
  429: 'Trop de tentatives. Réessayez dans quelques instants.',
};

const COMPANY_ERROR_FALLBACK = 'Une erreur est survenue dans la console entreprise.';

export class CompanyUiError extends Error {}

export function getCompanyErrorMessage(error: unknown) {
  if (error instanceof CompanyUiError) return error.message;

  if (error instanceof ApiError) {
    if (error.code && COMPANY_ERROR_MESSAGES[error.code]) {
      return COMPANY_ERROR_MESSAGES[error.code];
    }
    return HTTP_ERROR_MESSAGES[error.status] ?? COMPANY_ERROR_FALLBACK;
  }

  return COMPANY_ERROR_FALLBACK;
}
